import React, { createContext, useContext, useState } from "react"
import { useLocation } from "react-router-dom"
//import { useLocation, useSearchParams } from "react-router-dom"
//import { formatDateLocaleBr, getDevice } from "services/utils"
//import { useNavigate } from 'react-router-dom'
import { history } from '../../services/history'

const HistoryContext  = createContext(null)

export const HistoryProvider = ({ children }) => {

    
    const [ action      , setAction       ] = useState('')
    const [ canRedirect , setCanRedirect  ] = useState(false)
    const [ previousPath, setPreviousPath ] = useState('')
    const [ currentPath , setCurrentPath  ] = useState('')
    const [ historyPaths, setHistoryPaths ] = useState(new Set([]))

    // const [ dadosMarketing, setDadosMarketing ] = useState({
    //     afiliado: '',
    //     pagina_anterior: '',
    //     session: '',
    //     campanha: '',
    //     midia: '',
    //     entrou_em_agendamento: '',
    //     data_hora_agendamento: '',
    //     device: '',
    // })

    //console.log(dadosMarketing, "dadosMarketing")

    //const [searchParams] = useSearchParams()
    
    const location = useLocation()

    React.useEffect(() => {
        setCurrentPath(location.pathname)
        if (location.pathname !== currentPath) {
          setPreviousPath(currentPath)  
        }
        
        // eslint-disable-next-line
    }, [location.pathname])

    React.useEffect( () => {

        history.listen( ({ action }) => {
            //setCurrentPath(location.pathname)
            if (!canRedirect) { 
                setAction(action)
            }
        })
        // eslint-disable-next-line
    }, [])

    // React.useEffect( () => {
        
    //     if (window.location.pathname === '/agendamento') {
    //         setDadosMarketing( prevState => ({ 
    //                 ...prevState, 
    //                 afiliado: searchParams.get('afiliado') ?? '',
    //                 pagina_anterior: document.referrer,
    //                 entrou_em_agendamento: formatDateLocaleBr(),
    //                 device: getDevice() 
    //             }) 
    //         ) 
    //     }    
        
    // }, [setDadosMarketing, searchParams])

 
    //console.log(canRedirect, "CANREDIRECT")

    return (
        <HistoryContext.Provider value={{ 
            action      , setAction, 
            currentPath , setCurrentPath,
            canRedirect , setCanRedirect,
            previousPath, setPreviousPath, 
            historyPaths, setHistoryPaths
        }} >
            {children}
        </HistoryContext.Provider>
    )
} 

export const useHistory = () => useContext(HistoryContext)
